module.exports = __webpack_public_path__ + "img/signet-l.7af9ae93.svg";